var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 103,
    viewBox: "0 0 116 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "122.685%",
    x2: "43.051%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "135.879%",
    x2: "41.79%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-13h120v120H-2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.857 -2.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.697,
    cy: 103.773,
    fill: "#D8D8D8",
    fillRule: "nonzero",
    rx: 1.369,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M23.413 92.14C12.318 82.916 5.255 69.015 5.255 53.465c0-4.796.672-9.434 1.927-13.827-.028-.024-1.72-1.545-5.075-4.563a6.362 6.362 0 0 1-.471-8.99 6.372 6.372 0 0 1 8.995-.47l4.95 4.454c.15.135.293.276.428.421a4.246 4.246 0 0 0 4.33-1.099 4.239 4.239 0 0 0-.104-5.996l-2.815-2.716c.004-.004-.81-.802-2.443-2.393a4.239 4.239 0 0 1-.105-5.997 4.246 4.246 0 0 1 6-.104l7.552 7.287a4.247 4.247 0 0 0 4.647-.986 4.234 4.234 0 0 0 1.121-3.712l-8.038-7.757a2.081 2.081 0 0 1-.051-2.945c.799-.827 2.118-.85 2.946-.051l4.415 4.26a50.142 50.142 0 0 1 22.11-5.1c27.79 0 50.318 22.512 50.318 50.284 0 1-.03 1.995-.087 2.981l7.185 6.934a4.239 4.239 0 0 1 .105 5.997 4.246 4.246 0 0 1-6 .104l-6.218-6a2.084 2.084 0 0 0-1.974 3.514l.75.723c.462.242.902.545 1.308.91l4.95 4.455a6.362 6.362 0 0 1 .472 8.99 6.372 6.372 0 0 1-8.995.47l-.465-.417c-2.498 3.593-6.084 7.187-9.412 10.014"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.913,
    cy: 6.25,
    fill: "url(#b)",
    fillRule: "nonzero",
    rx: 4.448,
    ry: 3.764,
    transform: "rotate(45 9.913 6.25)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.345 93.85h32.164M47.562 93.85h22.583M72.198 93.85h26.69M101.625 93.85h4.106M29.085 98.64h16.438M52.352 98.64h16.439M68.777 102.062h28.058"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.159,
    cy: 75.716,
    stroke: "#80959D",
    strokeLinecap: "square",
    rx: 2.053,
    ry: 2.053
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.482,
    cy: 33.367,
    stroke: "#80959D",
    strokeLinecap: "square",
    rx: 2.053,
    ry: 2.053
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.283 39.008v2.933M106.074 43.212h-2.738M101.177 47.416v-2.933M97.177 42.764h2.737"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#738E99",
    fillRule: "nonzero",
    d: "M15.57 44.872h1.928v.646h-1.927v1.992h-.65v-1.992h-1.918v-.646h1.918V42.87h.65zM7.986 12.025h1.927v.646H7.986v1.993h-.65V12.67H5.416v-.646h1.918v-2.002h.65z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M46.725 49.309l17.42-10.058 8.857 15.341-17.42 10.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M50.712 49.929l14.507-8.197 7.421 12.854-14.506 8.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    strokeWidth: 1.05,
    d: "M58.915 50.306l6.533-3.771 2.847 4.931-6.533 3.772z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M56.215 65.746l20.687-11.944 10.439 18.08-20.687 11.944z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M60.202 66.366l17.965-10.372 9.174 15.889-17.965 10.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    strokeWidth: 1.05,
    d: "M70.545 60.394l4.9-2.828 4.112 7.122-4.9 2.829z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M32.762 39.331c2.802-1.568 5-.971 6.594 1.79l19.402 33.605"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "rotate(-30 176.253 -50.406)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.286,
    cy: 6.327,
    fill: "#FFF",
    stroke: "#64808C",
    rx: 6.286,
    ry: 6.327
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.286,
    cy: 6.327,
    fill: "#87D5FA",
    rx: 3.772,
    ry: 3.796
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M65.056 86.01l.947 1.64L74.057 83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M34.562 80.291l2.59-.045m2.659-.046l9.835-.172M34.65 85.352l2.59-.045m2.66-.047l9.835-.171M30.207 82.898l2.59-.045m2.658-.046l9.836-.172"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicker);
export default __webpack_public_path__ + "static/media/picker.6e5cca3c8daa484439fd0daba7900a21.svg";
export { ForwardRef as ReactComponent };